<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold"
          >manage transporters trucks</small
        >
      </legend>
      <button class="btn btn-success btn-roundec" @click="loadTruck()">
        <i class="fa fa-file-pdf-o"></i> TRUCK LIST
      </button>
      <p></p>
      <div></div>
      <div>
        <div class="trucksLoader">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <i
            class="fa fa-spinner fa-spin"
            style="font-size: 24px; color: blue"
          ></i
          >loading trucks...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemTrucks"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'faulty_status'">
              <span v-if="props.row.Faulty_status === 0">
                <button class="btn btn-info btn-sm btn-flat">
                  <i class="fa fa-level-up"></i> NOT FAULTY
                </button>
              </span>
              <span v-else-if="props.row.Faulty_status === 1">
                <button class="btn btn-danger btn-sm">
                  <i class="fa fa-level-down"></i> FAULTY
                </button>
              </span>
            </span>
            <span v-if="props.column.field == 'truck_status'">
              <span v-if="props.row.Truck_status === 0">
                <button class="btn btn-info btn-sm btn-flat">
                  <i class="fa fa-level-up"></i> AVAILABLE
                </button>
              </span>
              <span v-else-if="props.row.Truck_status === 1">
                <button class="btn btn-danger btn-sm">
                  <i class="fa fa-level-down"></i> ENROUTE
                </button>
              </span>
            </span>

            <span v-else-if="props.column.field == 'Action'">
              <button
                v-b-tooltip.hover.bottom="'Edit truck!'"
                class="btn btn-primary btn-sm btn-rounded"
                @click="viewTruck(props.row.id)"
              >
                <i class="fa fa-edit"></i> Edit Trucks
              </button>
            </span>

            <!-- <span v-else-if="props.column.field == 'Interchange'">
              <button
                v-b-tooltip.hover.bottom="'Interchange!'"
                class="btn btn-primary btn-sm btn-rounded"
                @click="viewTruckInterchange(props.row.id)"
              >
                <i class="fa fa-edit"></i> Interchange
              </button>
            </span> -->
            <span v-else>{{ props.formattedRow[props.column.field] }}</span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Transporter name",
          field: "transporter_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter transporter",
          },
        },
        {
          label: "Truck number",
          field: "truck_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter truck number",
          },
        },
        {
          label: "Trailer number",
          field: "trailer_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter trailer number",
          },
        },
        {
          label: "Truck license Date",
          field: "truck_license_Date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy",
          filterOptions: {
            enabled: true, // enable filter for this column
          }, // outputs Mar 16th 2018
        },
        {
          label: "Truck Expiry date",
          field: "truck_expiry_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy",
          filterOptions: {
            enabled: true, // enable filter for this column
          }, // outputs Mar 16th 2018
        },
        {
          label: "Trailer License date",
          field: "trailer_license_Date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy",
          filterOptions: {
            enabled: true, // enable filter for this column
          }, // outputs Mar 16th 2018
        },
        {
          label: "Trailer Expiry date",
          field: "trailer_expiry_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy",
          filterOptions: {
            enabled: true, // enable filter for this column
          }, // outputs Mar 16th 2018
        },
        {
          label: "Truck status",
          field: "truck_status",
          type: "text",
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true,
        },
        // {
        //   label: "Interchange",
        //   field: "Interchange",
        //   width: "122px",
        //   html: true,
        // },
      ],
    };
  },
  created() {
    this.loadTrucks();
  },
  computed: {
    ...mapGetters(["systemTrucks"]),
  },
  methods: {
    ...mapActions([
      "loadTrucks",
      "viewTruck",
      "loadTruck",
      "viewTruckInterchange",
    ]),
  },
};
</script>


// WEBPACK FOOTER //
// src/trucks/managetrucks.vue